import React, { useState, useEffect } from "react";
import classes from './Payment.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import svg from "../../Assets/SVG.jpg";
import { Eye, Printer, Trash, Edit } from "lucide-react";
import swal from "sweetalert";

import filter from "../../Assets/SVG (1).png";
import exports from "../../Assets/file-export.png";
import invoice from "../../Assets/invoice-04.png";
import vector from "../../Assets/Vector.svg";
import date from "../../Assets/SVG (2).png";
import exported from "../../Assets/SVG (4).png";
import Footer from "../../Components/Footer/Footer";
import CashReciept from "./CashReciept/CashReciept";
import api, { withCompanyId } from "../../Components/API/Api";
import CreateEmployee from "./CashReciept/CashReciept";

const EmployeeRecord = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // store employees fetched from /v1/employee
    const [employees, setEmployees] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    // view-only modal state
    const [viewOpen, setViewOpen] = useState(false);
    const [viewEmployee, setViewEmployee] = useState(null);
    // edit modal state & form
    const [editOpen, setEditOpen] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);
    const [editForm, setEditForm] = useState({
        first_name: "",
        last_name: "",
        sex: "",
        employee_id: "",
        home_address: "",
        nin: "",
        email: "",
        phone_no: "",
        dob: "",
        marital_status: "",
        department: "",
        unit: "",
        employment_type: "",
        emp_type: "",
        job_title: "",
        grade: "",
        step: "",
        date_of_first_appointment: "",
        manager_name: "",
        employment_status: "",
        emp_status: "",
        bank_name: "",
        account_number: "",
        basic_salary: "",
        next_of_kin_name: "",
        relationship: "",
        next_of_kin_phone: "",
        next_of_kin_address: "",
        photo: ""
    }); 
    const [editErrors, setEditErrors] = useState({});
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openCashReciept, setOpenCashReciept] = useState(false);
    const [loading, setLoading] = useState(true);
    // Template modal states
    const [templateModalOpen, setTemplateModalOpen] = useState(false);
    const [templateUploadFile, setTemplateUploadFile] = useState(null);
    const [uploadingTemplate, setUploadingTemplate] = useState(false);
    const [downloadingTemplate, setDownloadingTemplate] = useState(false);
    // Grade, step, and basic salary fetching for edit modal
    const [gradeOptions, setGradeOptions] = useState([]);
    const [stepOptions, setStepOptions] = useState([]);
    const [gradeLoading, setGradeLoading] = useState(false);
    const [stepLoading, setStepLoading] = useState(false);
    const [fetchingSalary, setFetchingSalary] = useState(false);
    // Banks for bank select in edit modal
    const [bankOptions, setBankOptions] = useState([]);
    const [banksLoading, setBanksLoading] = useState(false);
    // Employee Type and Status for edit modal
    const [empTypeOptions, setEmpTypeOptions] = useState([]);
    const [empStatusOptions, setEmpStatusOptions] = useState([]);
    const [empTypeLoading, setEmpTypeLoading] = useState(false);
    const [empStatusLoading, setEmpStatusLoading] = useState(false);

    const [baseCurrencyCode, setBaseCurrencyCode] = useState("NGN");
    const [companyId, setCompanyId] = useState(null);
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [totalEmployees, setTotalEmployees] = useState(0);
    const [perPage, setPerPage] = useState(100);

    useEffect(() => {
        const getBaseCurrencyCode = async () => {
            try {
                const token = localStorage.getItem("authToken");


                const companyRes = await api.get(`/v1/companies/get-info`);

                const companyData = Array.isArray(companyRes?.data?.data)
                    ? companyRes.data.data[0]
                    : companyRes?.data?.data;

                // store company id if available for uploads/downloads
                const resolvedCompanyId = companyData?.company_id || companyData?.id || companyData?.companyId || null;
                if (resolvedCompanyId) setCompanyId(resolvedCompanyId);

                const currencyId = companyData?.currency_base;


                const currenciesRes = await api.get(`/v1/fetch-all-currencies`);

                if (currenciesRes.data?.data && Array.isArray(currenciesRes.data.data)) {

                    const baseCurrency = currenciesRes.data.data.find(
                        currency => String(currency.id) === String(currencyId)
                    );

                    if (baseCurrency && baseCurrency.code) {
                        setBaseCurrencyCode(baseCurrency.code);
                    } else {
                        setBaseCurrencyCode("NGN");
                    }
                }

            } catch (err) {
                console.error("Failed to fetch base currency", err);
                setBaseCurrencyCode("NGN"); // Fallback
            }
        };

        getBaseCurrencyCode();
    }, []);
    // fetch employees from /v1/employee/paginated
    useEffect(() => {
        const fetchEmployees = async (page = 1) => {
            try {
                const res = await api.get(`/v1/employee/paginated`, {
                    params: { page }
                });

                // API returns { status: true, message: "...", data: { current_page, data: [...], last_page, total, per_page, ...} }
                // Extract the employees array and pagination metadata from the paginated response
                const result = Array.isArray(res?.data?.data?.data) ? res.data.data.data : [];
                const paginationData = res?.data?.data || {};
                
                console.log("Fetched employees:", result);
                setEmployees(result);
                setCurrentPage(paginationData.current_page || 1);
                setLastPage(paginationData.last_page || 1);
                setTotalEmployees(paginationData.total || 0);
                setPerPage(paginationData.per_page || 100);
            } catch (error) {
                console.error("Error fetching employees:", error);
                setEmployees([]);
            } finally {
                setLoading(false);
            }
        };

        fetchEmployees();
    }, []);



    const allSelected = selectedRows.length === employees.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(employees.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    // Pagination handlers
    const handlePageChange = (pageNum) => {
        if (pageNum === currentPage || pageNum < 1 || pageNum > lastPage) return;
        
        setLoading(true);
        const fetchEmployees = async () => {
            try {
                const res = await api.get(`/v1/employee/paginated`, {
                    params: { page: pageNum }
                });
                const result = Array.isArray(res?.data?.data?.data) ? res.data.data.data : [];
                const paginationData = res?.data?.data || {};
                setEmployees(result);
                setCurrentPage(paginationData.current_page || pageNum);
                setLastPage(paginationData.last_page || 1);
                setTotalEmployees(paginationData.total || 0);
                setPerPage(paginationData.per_page || 100);
                window.scrollTo(0, 0); // Scroll to top
            } catch (error) {
                console.error("Error fetching page:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchEmployees();
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < lastPage) {
            handlePageChange(currentPage + 1);
        }
    };

    // open employee detail (passes employee object via router state)
    const handleOpenReceipt = (employee) => {
        navigate('/employee-detail', { state: { employee } });
    };

    // open view-only modal (non-editable)
    const handleViewClick = (emp) => {
        setViewEmployee(emp);
        setViewOpen(true);
    };

    // Fetch grades and steps when edit modal opens
    useEffect(() => {
        if (!editOpen) return;
        const fetchGradesAndSteps = async () => {
            try {
                setGradeLoading(true);
                setStepLoading(true);
                const token = localStorage.getItem("authToken");
                const [gradesRes, stepsRes] = await Promise.all([
                    api.get('/v1/get-grades'),
                    api.get('/v1/get-steps'),
                ]);
                const grades = Array.isArray(gradesRes?.data?.data) ? gradesRes.data.data : [];
                const steps = Array.isArray(stepsRes?.data?.data) ? stepsRes.data.data : [];
                setGradeOptions(grades);
                setStepOptions(steps);
            } catch (err) {
                console.error("Failed to fetch grades/steps:", err);
                setGradeOptions([]);
                setStepOptions([]);
            } finally {
                setGradeLoading(false);
                setStepLoading(false);
            }
        };
        fetchGradesAndSteps();
    }, [editOpen]);

    // Fetch banks for Bank select when edit modal opens
    useEffect(() => {
        if (!editOpen) return;
        const fetchBanks = async () => {
            setBanksLoading(true);
            try {
                const res = await api.get('/v1/paystack/banks');

                const banks = Array.isArray(res?.data?.data) ? res.data.data : (Array.isArray(res?.data) ? res.data : []);
                setBankOptions(banks);
            } catch (err) {
                console.error("Failed to fetch paystack banks:", err);
                setBankOptions([]);
            } finally {
                setBanksLoading(false);
            }
        };

        fetchBanks();
    }, [editOpen]);

    // Fetch employee type and status options when edit modal opens
    useEffect(() => {
        if (!editOpen) return;
        const fetchEmpTypeAndStatus = async () => {
            try {
                setEmpTypeLoading(true);
                setEmpStatusLoading(true);
                const [empTypeRes, empStatusRes] = await Promise.all([
                    api.get('/v1/employee/employement_type'),
                    api.get('/v1/employee/employement_status'),
                ]);
                const empTypes = Array.isArray(empTypeRes?.data?.data) ? empTypeRes.data.data : [];
                const empStatuses = Array.isArray(empStatusRes?.data?.data) ? empStatusRes.data.data : [];
                setEmpTypeOptions(empTypes);
                setEmpStatusOptions(empStatuses);
            } catch (err) {
                console.error("Failed to fetch employment types/status:", err);
                setEmpTypeOptions([]);
                setEmpStatusOptions([]);
            } finally {
                setEmpTypeLoading(false);
                setEmpStatusLoading(false);
            }
        };
        fetchEmpTypeAndStatus();
    }, [editOpen]);

    // Fetch basic salary when grade and step are selected in edit form
    useEffect(() => {
        // Only fetch when modal is open and both grade and step are set
        if (!editOpen || !editForm.grade || !editForm.step) {
            return;
        }

        const fetchBasicSalary = async () => {
            setFetchingSalary(true);
            try {
                const res = await api.get('/v1/payroll/salary_structure/get_specified', {
                    params: {
                        grade: editForm.grade,
                        step: editForm.step,
                        basic_salary: true
                    }
                });

                // Extract basic salary from response by filtering for matching grade_id and step_id
                let basicSalary = null;
                
                if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
                  // Find the salary structure that matches both grade_id and step_id
                  const matchingStructure = res.data.data.find(
                    (item) => 
                      String(item.grade_id) === String(editForm.grade) && 
                      String(item.step_id) === String(editForm.step)
                  );
                  
                  if (matchingStructure && matchingStructure.basic_salary) {
                    basicSalary = matchingStructure.basic_salary;
                  }
                } else if (res?.data?.data?.basic_salary) {
                  // Fallback if response is not an array
                  basicSalary = res.data.data.basic_salary;
                } else if (res?.data?.basic_salary) {
                  // Another fallback
                  basicSalary = res.data.basic_salary;
                }

                if (basicSalary) {
                    setEditForm(prev => ({ ...prev, basic_salary: String(basicSalary) }));
                }
            } catch (err) {
                console.error("Failed to fetch basic salary:", err);
            } finally {
                setFetchingSalary(false);
            }
        };

        // Add a small delay to avoid fetching during initial form population
        const timer = setTimeout(() => {
            fetchBasicSalary();
        }, 100);

        return () => clearTimeout(timer);
    }, [editOpen, editForm.grade, editForm.step]);

    // populate edit form and open modal
    const handleEditClick = (emp) => {
        setEditingEmployee(emp);
        setEditErrors({});
        setEditForm({
            first_name: emp.first_name || "",
            last_name: emp.last_name || "",
            sex: emp.sex || "",
            employee_id: emp.employee_id || "",
            home_address: emp.home_address || "",
            nin: emp.nin || "",
            email: emp.email || "",
            phone_no: emp.phone_no || "",
            dob: emp.dob || "",
            marital_status: emp.marital_status || "",
            department: emp.department || "",
            unit: emp.unit || "",
            employment_type: emp.employment_type || (emp.emp_type?.id ? String(emp.emp_type.id) : ""),
            emp_type: "",
            job_title: emp.job_title || "",
            grade: emp.grade || "",
            step: emp.step || "",
            date_of_first_appointment: emp.date_of_first_appointment || "",
            manager_name: emp.manager_name || "",
            employment_status: emp.employment_status || (emp.emp_status?.id ? String(emp.emp_status.id) : ""),
            emp_status: "",
            // prefer bank id if available, otherwise bank name
            bank_name: emp.bank_id || emp.bank_name || "",
            account_number: emp.account_number || "",
            basic_salary: emp.basic_salary || "",
            next_of_kin_name: emp.next_of_kin_name || "",
            relationship: emp.relationship || "",
            next_of_kin_phone: emp.next_of_kin_phone || "",
            next_of_kin_address: emp.next_of_kin_address || "",
            photo: emp.photo || ""
        });
        setEditOpen(true);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditForm(prev => ({ ...prev, [name]: value }));
    };

    const handleUpdateEmployee = async () => {
        if (!editingEmployee) return;
        setIsUpdating(true);
        try {
                const token = localStorage.getItem("authToken");

                // determine bank_id and readable bank_name from selected value
                const selectedBankVal = editForm.bank_name || "";
                let bank_id = selectedBankVal;
                let bank_name = selectedBankVal;
                if (Array.isArray(bankOptions) && bankOptions.length > 0) {
                    const found = bankOptions.find(b =>
                        String(b.id) === String(selectedBankVal) ||
                        String(b.code) === String(selectedBankVal) ||
                        String(b.bank_code) === String(selectedBankVal)
                    );
                    if (found) {
                        bank_id = found.id || found.code || bank_id;
                        bank_name = found.name || found.bank_name || found.full_name || bank_name;
                    }
                }

                // Build payload with explicit field filtering
                const payloadData = {
                    first_name: editForm.first_name || "",
                    last_name: editForm.last_name || "",
                    sex: editForm.sex || "",
                    employee_id: editForm.employee_id || "",
                    home_address: editForm.home_address || "",
                    nin: editForm.nin || "",
                    email: editForm.email || "",
                    phone_no: editForm.phone_no || "",
                    dob: editForm.dob || "",
                    marital_status: editForm.marital_status || "",
                    department: editForm.department || "",
                    unit: editForm.unit || "",
                    employment_type: editForm.employment_type || "",
                    job_title: editForm.job_title || "",
                    date_of_first_appointment: editForm.date_of_first_appointment || "",
                    manager_name: editForm.manager_name || "",
                    employment_status: editForm.employment_status || "",
                    account_number: editForm.account_number || "",
                    basic_salary: editForm.basic_salary || "",
                    next_of_kin_name: editForm.next_of_kin_name || "",
                    relationship: editForm.relationship || "",
                    next_of_kin_phone: editForm.next_of_kin_phone || "",
                    next_of_kin_address: editForm.next_of_kin_address || ""
                };

                // Only include photo if it has an actual value
                if (editForm.photo && String(editForm.photo).trim() !== "") {
                    payloadData.photo = editForm.photo;
                }
                
                // Only include grade and step if they have actual values
                if (editForm.grade && String(editForm.grade).trim() !== "") {
                    payloadData.grade = editForm.grade;
                }
                if (editForm.step && String(editForm.step).trim() !== "") {
                    payloadData.step = editForm.step;
                }
                
                const payload = { id: editingEmployee.id, ...payloadData, bank_id, bank_name };
                
                // Final filter: remove any undefined values and ensure grade/step are not empty strings
                Object.keys(payload).forEach(key => {
                    if (key === 'grade' || key === 'step' || key === 'employment_type' || key === 'employment_status') {
                        if (!payload[key] || String(payload[key]).trim() === '') {
                            delete payload[key];
                        }
                    }
                });
                
                console.log("DEBUG: Payload being sent:", payload);
                console.log("DEBUG: Grade value:", payload.grade);
                console.log("DEBUG: Step value:", payload.step);
                
                const res = await api.post('/v1/employee/update', withCompanyId(payload));
            // if server returns validation errors under message.error
            if (res?.data?.message && res.data.message.error) {
                setEditErrors(res.data.message.error);
                return;
            }
            // update local state: replace the updated employee
            const updated = Array.isArray(res?.data?.data) ? res.data.data : res?.data?.data || null;
            // the API might return the updated record, otherwise merge form into local object
            const updatedEmp = updated || { ...editingEmployee, ...editForm, bank_id: payload.bank_id, bank_name: payload.bank_name };
            setEmployees(prev => prev.map(e => (e.id === editingEmployee.id ? updatedEmp : e)));
            setEditOpen(false);
            setEditingEmployee(null);
            setEditErrors({});
            // show swal success alert
            swal("Success", "Employee updated successfully.", "success");
        } catch (err) {
            // try to read validation errors if present
            if (err?.response?.data?.message?.error) {
                setEditErrors(err.response.data.message.error);
            } else {
                console.error("Failed to update employee", err);
            }
        } finally {
            setIsUpdating(false);
        }
    };

        // Template download and upload handlers
        const handleDownloadTemplate = async () => {
            try {
                setDownloadingTemplate(true);
                const res = await api.get('/v1/download_employee_template', { responseType: 'blob' });

                const blob = new Blob([res.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                // try to infer extension; default to xlsx
                link.setAttribute('download', 'employee_template.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error('Failed to download template', err);
                swal('Error', 'Failed to download template.', 'error');
            } finally {
                setDownloadingTemplate(false);
            }
        };

        const handleFileChange = (e) => {
            const file = e.target.files && e.target.files[0];
            setTemplateUploadFile(file || null);
        };

        const handleUploadTemplate = async () => {
            if (!templateUploadFile) {
                swal('Error', 'Please select a file to upload.', 'error');
                return;
            }
            setUploadingTemplate(true);
            try {
                    const fd = new FormData();
                    fd.append('file', templateUploadFile);

                    // Ensure company_id is included
                    let cid = companyId;
                    if (!cid) {
                        try {
                            const infoRes = await api.get('/v1/companies/get-info');
                            const infoData = Array.isArray(infoRes?.data?.data) ? infoRes.data.data[0] : infoRes?.data?.data;
                            cid = infoData?.company_id || infoData?.id || infoData?.companyId || null;
                            if (cid) setCompanyId(cid);
                        } catch (e) {
                            console.warn('Could not fetch company id for upload', e);
                        }
                    }

                    if (cid) {
                        fd.append('company_id', cid);
                    }

                const res = await api.post('/v1/employee/upload', withCompanyId(fd), {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                swal('Success', res?.data?.message || 'Template uploaded successfully.', 'success');
                setTemplateModalOpen(false);
                setTemplateUploadFile(null);
                // Optionally refresh employees
                // fetchEmployees(); // not available in this scope
            } catch (err) {
                console.error('Failed to upload template', err);
                swal('Error', err?.response?.data?.message || 'Upload failed.', 'error');
            } finally {
                setUploadingTemplate(false);
            }
        };

    // single-line ellipsis style for table cells
    const ellipsisStyle = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 180,
        display: "block",
        cursor: "pointer"
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Employee Records</h2>
                    <h1 className={classes.Titles}>
                        View all Employee Records and and payments in chronological order.
                    </h1>
                </header>

                {/* === Metrics Cards === */}
                {/* <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total debits</p>
                                <p className={classes.kdptg1}>
                                    {selectMetrics?.total_debits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Credits</p>
                                <p className={classes.kdptg2}>
                                    {selectMetrics?.total_credits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Trial balance</p>
                                <p className={classes.kdptg3}>
                                    {selectMetrics?.trial_balance?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Balanced</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Entries</p>
                                <p className={classes.kdptg4}>
                                    {selectMetrics?.total_entries?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* === Header Actions === */}
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="svg" className={classes.searchIcon} />
                            <input type="text" className={classes.searchBar} placeholder="Search ledger..." />
                        </div>

                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All accounts</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={date} alt="date" className={classes.dateicon} />
                            <input type="text" className={classes.thirdBar} placeholder="Date Range" />
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={filter} alt="Filter" className={classes.filterIcon} />
                            <input type="text" className={classes.secondBar} placeholder="Filter" />
                        </div>
                    </div>

                    <div className={classes.inputWrapper}>
                        <div className={classes.inputWrapper} style={{ display: 'inline-block', marginRight: 8 }}>
                            <button className={classes.btnss} onClick={() => setTemplateModalOpen(true)}>
                                <img src={exports} alt="template" className={classes.invoiceIcon} />
                                Upload Employees
                            </button>
                        </div>

                        <button className={classes.btnss} onClick={() => setOpenCashReciept(true)}>
                            <img src={exported} alt="added" className={classes.invoiceIcon} />
                            New Record
                        </button>
                    </div>
                </div>

                {/* === Payments Table === */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Employee ID</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Department</th>
                                {/* <th>Address</th> */}
                                <th>Created at</th>
                                <th>{baseCurrencyCode} Salary</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                // ✅ Skeleton loader — 7 rows, 7 columns
                                Array.from({ length: 9 }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {[...Array(8)].map((_, colIndex) => (
                                            <td key={colIndex}>
                                                <div className={classes.skeletonBox}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : Array.isArray(employees) && employees.length > 0 ? (
                                employees.map((emp, index) => (
                                    <tr key={emp.id || index}>
                                        <td>
                                            <div style={ellipsisStyle} title={emp.employee_id || `#${index + 1}`}>
                                                {emp.employee_id || `#${index + 1}`}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={ellipsisStyle} title={emp.name || `${emp.first_name || ""} ${emp.last_name || ""}`.trim()}>
                                                {emp.name || `${emp.first_name || ""} ${emp.last_name || ""}`.trim() || "—"}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={ellipsisStyle} title={emp.phone_no || "—"}>
                                                {emp.phone_no || "—"}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={ellipsisStyle} title={emp.email || "—"}>
                                                {emp.email || "—"}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={ellipsisStyle} title={emp.department || "—"}>
                                                {emp.department || "—"}
                                            </div>
                                        </td>
                                        {/* <td>{emp.home_address || "—"}</td> */}
                                        <td>
                                            <div style={ellipsisStyle} title={emp.created_at ? new Date(emp.created_at).toLocaleString() : "—"}>
                                                {emp.created_at ? new Date(emp.created_at).toLocaleString() : "—"}
                                            </div>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            <div style={{ ...ellipsisStyle, textAlign: "right", maxWidth: 140 }} title={emp.basic_salary ? `${Number(emp.basic_salary).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${baseCurrencyCode}` : "—"}>
                                                {emp.basic_salary ? Number(emp.basic_salary).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—"} {emp.basic_salary ? baseCurrencyCode : ""}
                                            </div>
                                        </td>
                                        <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                            <span
                                                onClick={() => handleViewClick(emp)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleViewClick(emp); }}
                                                style={{ margin: "0 8px", color: "rgb(37, 99, 235)", cursor: "pointer" }}
                                                aria-label={`View employee ${emp.employee_id || emp.name}`}
                                            >
                                                <Eye size={16} style={{ color: "rgb(22,163,74)", cursor: "pointer" }} />
                                            </span>
                                            {/* edit (pen) icon */}
                                            <span
                                                onClick={() => handleEditClick(emp)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleEditClick(emp); }}
                                                style={{ margin: "0 8px", color: "rgb(37, 99, 235)", cursor: "pointer" }}
                                                aria-label={`Edit employee ${emp.employee_id || emp.name}`}
                                            >
                                                <Edit size={16} />
                                            </span>
                                            <span
                                                onClick={() => handleOpenReceipt(emp)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleOpenReceipt(emp); }}
                                                style={{ margin: "0 8px", color: "rgba(235, 166, 37, 1)", cursor: "pointer" }}
                                                aria-label={`Open employee ${emp.employee_id || emp.name}`}
                                            >
                                                <Printer size={16} />
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center" }}>
                                        No employee records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* Pagination Controls */}
                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td 
                                className={classes.frston}
                                onClick={() => handlePageChange(1)}
                                style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.5 : 1 }}
                            >
                                First
                            </td>
                            {Array.from({ length: lastPage }, (_, i) => i + 1).map((page) => (
                                <td
                                    key={page}
                                    className={`${classes.page} ${page === currentPage ? classes.activePage : ""}`}
                                    onClick={() => handlePageChange(page)}
                                    style={{
                                        cursor: page === currentPage ? "default" : "pointer",
                                        opacity: page === currentPage ? 1 : 0.7
                                    }}
                                >
                                    {page}
                                </td>
                            ))}
                            <td 
                                className={classes.lastno}
                                onClick={() => handlePageChange(lastPage)}
                                style={{ cursor: currentPage === lastPage ? "not-allowed" : "pointer", opacity: currentPage === lastPage ? 0.5 : 1 }}
                            >
                                Last
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.lasone}>
                    <div className={classes.paginationDisplay}>
                        Displaying {((currentPage - 1) * perPage) + 1} - {Math.min(currentPage * perPage, totalEmployees)} of {totalEmployees}
                    </div>
                </div>

                {/* Edit modal (simple inline modal) */}
                {editOpen && (
                    <div style={{
                        position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
                    }} onClick={() => { setEditOpen(false); setEditingEmployee(null); setEditErrors({}); }}>
                        <div style={{ width: 820, maxHeight: "85vh", overflowY: "auto", background: "#fff", padding: 20 }} onClick={(e) => e.stopPropagation()}>
                            <h3 style={{ marginTop: 0 }}>Edit employee</h3>
                            {/* show global errors if any */}
                            {editErrors && Object.keys(editErrors).length > 0 && (
                                <div style={{ color: "red", marginBottom: 8 }}>
                                    {Object.entries(editErrors).map(([k, v]) => (
                                        <div key={k}><strong>{k}:</strong> {(Array.isArray(v) ? v.join(", ") : v)}</div>
                                    ))}
                                </div>
                            )}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                                <input name="first_name" placeholder="First name" value={editForm.first_name} onChange={handleEditChange} />
                                <input name="last_name" placeholder="Last name" value={editForm.last_name} onChange={handleEditChange} />
                                <input name="sex" placeholder="Sex" value={editForm.sex} onChange={handleEditChange} />
                                <input name="employee_id" placeholder="Employee ID" value={editForm.employee_id} onChange={handleEditChange} />
                                <input name="phone_no" placeholder="Phone" value={editForm.phone_no} onChange={handleEditChange} />
                                <input name="email" placeholder="Email" value={editForm.email} onChange={handleEditChange} />
                                <input name="department" placeholder="Department" value={editForm.department} onChange={handleEditChange} />
                                <input name="unit" placeholder="Unit" value={editForm.unit} onChange={handleEditChange} />
                                <input name="home_address" placeholder="Home address" value={editForm.home_address} onChange={handleEditChange} />
                                <input name="nin" placeholder="NIN" value={editForm.nin} onChange={handleEditChange} />
                                <input name="dob" placeholder="DOB (YYYY-MM-DD)" value={editForm.dob} onChange={handleEditChange} />
                                <input name="marital_status" placeholder="Marital status" value={editForm.marital_status} onChange={handleEditChange} />
                                <input name="job_title" placeholder="Job title" value={editForm.job_title} onChange={handleEditChange} />
                                <div>
                                    <select 
                                        name="employment_type" 
                                        value={editForm.employment_type} 
                                        onChange={handleEditChange}
                                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px" }}
                                    >
                                        <option value="">{empTypeLoading ? "Loading types..." : "Select Employee Type"}</option>
                                        {empTypeOptions.map((et) => (
                                            <option key={et.id} value={et.id}>{et.name || et.description}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <select 
                                        name="employment_status" 
                                        value={editForm.employment_status} 
                                        onChange={handleEditChange}
                                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px" }}
                                    >
                                        <option value="">{empStatusLoading ? "Loading status..." : "Select Employee Status"}</option>
                                        {empStatusOptions.map((es) => (
                                            <option key={es.id} value={es.id}>{es.name || es.description}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <select 
                                        name="grade" 
                                        value={editForm.grade} 
                                        onChange={handleEditChange}
                                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px" }}
                                    >
                                        <option value="">{gradeLoading ? "Loading grades..." : "Select Grade"}</option>
                                        {gradeOptions.map((g) => (
                                            <option key={g.id} value={g.id}>{g.description}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <select 
                                        name="step" 
                                        value={editForm.step} 
                                        onChange={handleEditChange}
                                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px" }}
                                    >
                                        <option value="">{stepLoading ? "Loading steps..." : "Select Step"}</option>
                                        {stepOptions.map((s) => (
                                            <option key={s.id} value={s.id}>{s.description || s.name || `Step ${s.id}`}</option>
                                        ))}
                                    </select>
                                </div>
                                <input name="date_of_first_appointment" placeholder="Date of first appointment (YYYY-MM-DD)" value={editForm.date_of_first_appointment} onChange={handleEditChange} type="date" />
                                <input name="manager_name" placeholder="Manager name" value={editForm.manager_name} onChange={handleEditChange} />
                                <input 
                                    name="basic_salary" 
                                    placeholder={editForm.grade && editForm.step ? (fetchingSalary ? "Fetching..." : "Auto-populated from Grade/Step") : "Enter basic salary"} 
                                    value={editForm.basic_salary} 
                                    onChange={handleEditChange}
                                    disabled={editForm.grade && editForm.step ? true : false}
                                    style={{ 
                                        backgroundColor: editForm.grade && editForm.step ? "#f3f4f6" : "#ffffff",
                                        color: editForm.grade && editForm.step ? "#6b7280" : "#000000",
                                        cursor: editForm.grade && editForm.step ? "not-allowed" : "text",
                                        opacity: editForm.grade && editForm.step ? 0.7 : 1
                                    }}
                                    type="text"
                                />
                                <div>
                                    <select
                                        name="bank_name"
                                        value={editForm.bank_name}
                                        onChange={handleEditChange}
                                        style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px" }}
                                    >
                                        <option value="">{banksLoading ? "Loading banks..." : "Select Bank"}</option>
                                        {bankOptions.map((b, idx) => {
                                            const label = b.name || b.bank_name || b.bank || b.full_name || `Bank ${idx + 1}`;
                                            const value = b.id || b.code || b.bank_code || label;
                                            return (
                                                <option key={`${value}-${idx}`} value={value}>
                                                    {label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <input name="account_number" placeholder="Account number" value={editForm.account_number} onChange={handleEditChange} />
                                <input name="next_of_kin_name" placeholder="Next of kin name" value={editForm.next_of_kin_name} onChange={handleEditChange} />
                                <input name="next_of_kin_phone" placeholder="Next of kin phone" value={editForm.next_of_kin_phone} onChange={handleEditChange} />
                                <input name="next_of_kin_address" placeholder="Next of kin address" value={editForm.next_of_kin_address} onChange={handleEditChange} 
                                // style={{ gridColumn: "1 / -1" }} 
                                />
                                <input name="relationship" placeholder="Relationship" value={editForm.relationship} onChange={handleEditChange} />
                                <input name="photo" placeholder="Photo URL" value={editForm.photo} onChange={handleEditChange} style={{ gridColumn: "1 / -1" }} />
                            </div>
                            <div style={{ marginTop: 12, display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button onClick={() => { setEditOpen(false); setEditingEmployee(null); setEditErrors({}); }}>Cancel</button>
                                <button
                                    className={classes.saveBtn}
                                    onClick={handleUpdateEmployee}
                                    disabled={isUpdating}
                                    style={{ background: "#16a34a", color: "#fff", border: "none", padding: "8px 12px", borderRadius: 6, cursor: isUpdating ? "not-allowed" : "pointer" }}
                                >
                                    {isUpdating ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* View-only modal (opened by Eye icon) */}
                {viewOpen && viewEmployee && (
                    <div style={{
                        position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
                    }} onClick={() => { setViewOpen(false); setViewEmployee(null); }}>
                        <div style={{ width: 820, maxHeight: "85vh", overflowY: "auto", background: "#fff", padding: 20 }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                                <h3 style={{ margin: 0 }}>Employee details</h3>
                                <button onClick={() => { setViewOpen(false); setViewEmployee(null); }} style={{ fontSize: 18, lineHeight: 1, border: "none", background: "transparent", cursor: "pointer" }}>×</button>
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                                <div><strong>Employee ID</strong><div>{viewEmployee.employee_id || "—"}</div></div>
                                <div><strong>Name</strong><div>{viewEmployee.name || `${viewEmployee.first_name || ""} ${viewEmployee.last_name || ""}`.trim() || "—"}</div></div>
                                <div><strong>First name</strong><div>{viewEmployee.first_name || "—"}</div></div>
                                <div><strong>Last name</strong><div>{viewEmployee.last_name || "—"}</div></div>
                                <div><strong>Phone</strong><div>{viewEmployee.phone_no || "—"}</div></div>
                                <div><strong>Email</strong><div>{viewEmployee.email || "—"}</div></div>
                                <div><strong>Department</strong><div>{viewEmployee.department || "—"}</div></div>
                                <div><strong>Unit</strong><div>{viewEmployee.unit || "—"}</div></div>
                                <div><strong>Home address</strong><div>{viewEmployee.home_address || "—"}</div></div>
                                <div><strong>NIN</strong><div>{viewEmployee.nin || "—"}</div></div>
                                <div><strong>DOB</strong><div>{viewEmployee.dob || "—"}</div></div>
                                <div><strong>Marital status</strong><div>{viewEmployee.marital_status || "—"}</div></div>
                                <div><strong>Job title</strong><div>{viewEmployee.job_title || "—"}</div></div>
                                <div><strong>Employee Type</strong><div>{viewEmployee.emp_type?.name || "—"}</div></div>
                                <div><strong>Employee Status</strong><div>{viewEmployee.emp_status?.name || "—"}</div></div>
                                <div><strong>Manager</strong><div>{viewEmployee.manager_name || "—"}</div></div>
                                <div><strong>Basic salary</strong><div>{viewEmployee.basic_salary ? `${Number(viewEmployee.basic_salary).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${baseCurrencyCode}` : "—"}</div></div>
                                <div><strong>Bank</strong><div>{viewEmployee.bank_name || "—"}</div></div>
                                <div><strong>Account number</strong><div>{viewEmployee.account_number || "—"}</div></div>
                                <div style={{ gridColumn: "1 / -1" }}>
                                    <strong>Next of kin</strong>
                                    <div>
                                        {viewEmployee.next_of_kin_name ? `${viewEmployee.next_of_kin_name} — ${viewEmployee.relationship || ""} — ${viewEmployee.next_of_kin_phone || ""}` : "—"}
                                    </div>
                                    <div style={{ marginTop: 6 }}>{viewEmployee.next_of_kin_address || ""}</div>
                                </div>
                                <div style={{ gridColumn: "1 / -1" }}>
                                    <strong>Photo</strong>
                                    <div style={{ marginTop: 6 }}>
                                        {viewEmployee.photo ? <img src={viewEmployee.photo} alt="employee" style={{ maxWidth: 120, maxHeight: 120, borderRadius: 6 }} /> : "—"}
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end" }}>
                                <button onClick={() => { setViewOpen(false); setViewEmployee(null); }} style={{ padding: "8px 12px", borderRadius: 6, border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}>Close</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Template modal */}
                {templateModalOpen && (
                    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }} onClick={() => { setTemplateModalOpen(false); setTemplateUploadFile(null); }}>
                        <div style={{ width: 520, background: "#fff", padding: 20, borderRadius: 6 }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                <h3 style={{ margin: 0 }}>Upload Employees</h3>
                                <button onClick={() => { setTemplateModalOpen(false); setTemplateUploadFile(null); }} style={{ fontSize: 18, lineHeight: 1, border: "none", background: "transparent", cursor: "pointer" }}>×</button>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 12 }}>
                                <p style={{ margin: 0, color: '#374151' }}>Download the employee import template, fill it out, then upload it here.</p>

                                <div>
                                    <button className={classes.saveBtn} onClick={handleDownloadTemplate} disabled={downloadingTemplate} style={{ width: '180px', background: '#6b7280', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: 6, cursor: downloadingTemplate ? 'not-allowed' : 'pointer' }}>
                                        {downloadingTemplate ? 'Downloading...' : 'Download Template'}
                                    </button>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    <label style={{ fontSize: 13, color: '#6b7280' }}>Select filled template</label>
                                    <input type="file" accept=".xls,.xlsx,.csv" onChange={handleFileChange} />
                                    {templateUploadFile && (
                                        <div style={{ fontSize: 13, color: '#111827' }}>{templateUploadFile.name}</div>
                                    )}
                                    <div>
                                        <button onClick={handleUploadTemplate} disabled={uploadingTemplate} style={{ width: '180px', background: '#16a34a', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: 6, cursor: uploadingTemplate ? 'not-allowed' : 'pointer' }}>
                                            {uploadingTemplate ? 'Uploading...' : 'Upload Template'}
                                        </button>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                    <button onClick={() => { setTemplateModalOpen(false); setTemplateUploadFile(null); }} style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer' }}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* CreateEmployee Modal */}
                <CreateEmployee isOpen={openCashReciept} onClose={() => setOpenCashReciept(false)} />
            </div>

            <Footer />
        </div>
    );
};

export default EmployeeRecord;
